import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Errors, Game } from '../../Core'

/**
 *  Data cosume warning
 */
class DataConsumeWarning extends React.Component {
  /**
   *  contstructor
   */
  constructor(props) {
    super(props)
    this.state = {
      showAgain: true,
    }
  }

  /**
   *  closeMainMenu
   */
  closeScreen() {
    const { hideError, initGame, startSceneChange, toggleConsumeWarning } = this.props
    hideError(Errors.DATA_CONSUME)
    toggleConsumeWarning(this.state.showAgain)
    initGame()
    startSceneChange()
  }

  /**
   *  Render Component.
   */
  render() {
    return (
      <div className="container background--mars">
        <div className="content">
          <div className="alerts">
            <div className="alert--title">
              <FormattedMessage id={'dataConsume.title'} />
            </div>
            <div className="icon-wifi position--absolute top right"></div>
            <div className="alert--message">
              <FormattedMessage id={'dataConsume.content'} />
            </div>
            <div className="checkbox">
              <input
                onChange={(event) => this.setState({ showAgain: !event.target.checked })}
                type="checkbox"
                name="effects"
                id="effects"
              />
              <label htmlFor="effects">
                <FormattedMessage id={'dataConsume.no_show'} />
              </label>
            </div>
            <div
              className="btn--shape shape--red"
              onClick={() => {
                this.closeScreen()
              }}
            >
              <div className="btn--shape__canvas">
                <FormattedMessage id={'dataConsume.accept'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideError: bindActionCreators(Game.actions.hideError, dispatch),
    initGame: bindActionCreators(Game.actions.initGame, dispatch),
    startSceneChange: bindActionCreators(Game.actions.startSceneChange, dispatch),
    toggleConsumeWarning: bindActionCreators(Game.actions.toggleConsumeWarning, dispatch),
  }
}

DataConsumeWarning.propTypes = {
  hideError: PropTypes.func,
  initGame: PropTypes.func,
  startSceneChange: PropTypes.func,
  toggleConsumeWarning: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(DataConsumeWarning)
